import React from 'react';
import { useSelector } from 'react-redux';
import { GrowthBookFeature } from '@gumtree/shared/src/model/experiment';
import { useFeatureValue } from '@growthbook/growthbook-react';
import AppCommon from './app';
import AppService from './app-service';
import { selectState } from './selectors';

const MainApp = () => {
    const { adDetails } = useSelector(selectState);
    const isServices = adDetails?.l1CategorySeoName === 'business-services';
    const isUI_202506 = useFeatureValue(GrowthBookFeature.SERVICE_NEW_UI, 'A') === 'B' && isServices;

    const AppToRender = isUI_202506 ? AppService : AppCommon;

    return <AppToRender />
};

export default MainApp;
